import axios from "axios";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getNews = (branch) => api.get("/news", { params: { branch } }).then((r) => r.data);
export const getTrainings = (branch, sport) => api.get("/trainings", { params: { branch, sport } }).then((r) => r.data);
export const getActivities = (branch, type) => api.get("/activities", { params: { branch, type } }).then((r) => r.data);
export const getSocial = (branch) => api.get("/social", { params: { branch } }).then((r) => r.data);
export const postRegistration = (data) => api.post("/registrations", data).then((r) => r.data);
export const createPayment = (registration_id) => api.post("/payments/create", { registration_id }).then((r) => r.data);
export const getPaymentStatus = (registration_id) => api.get(`/payments/status/${registration_id}`).then((r) => r.data);
export const postContact = (data) => api.post("/contact", data).then((r) => r.data);
export const getTeamProfiles = (branch = "fc-inkad") => api.get("/teams", { params: { branch } }).then((r) => r.data);
export const getStaff = (branch = "fc-inkad") => api.get("/staff", { params: { branch } }).then((r) => r.data);
export const getGallery = (branch = "jeugd") => api.get("/gallery", { params: { branch } }).then((r) => r.data);

// Interne Sports API (officiële Voetbal Vlaanderen data via eigen backend)
export const getSportOverview = (sport) => api.get(`/sports/${sport}/overview`).then((r) => r.data);
export const getSportMatches = (sport, params) => api.get(`/sports/${sport}/matches`, { params }).then((r) => r.data);
export const getSportStandings = (sport, competitionId) => api.get(`/sports/${sport}/standings`, { params: { competition_id: competitionId } }).then((r) => r.data);
export const getSportTeams = (sport) => api.get(`/sports/${sport}/teams`).then((r) => r.data);
export const getSportCompetitions = (sport) => api.get(`/sports/${sport}/competitions`).then((r) => r.data);

// Beheer (beveiligd met toegangscode)
export const getAdminRegistrations = (code, branch) =>
  api.get("/admin/registrations", { params: branch ? { branch } : {}, headers: { "X-Admin-Code": code } }).then((r) => r.data);
export const verifyAdminCode = (code) =>
  api.post("/admin/verify", {}, { headers: { "X-Admin-Code": code } }).then((r) => r.data);

// Persartikels (Het Nieuwsblad via eigen backend)
export const getPress = () => api.get("/press").then((r) => r.data);
